import * as Converter from "./converter";

import type * as Repository from "../../_repository";

type Props = {
	option: Repository.Query.QueryData.OptionPmsList.Option;
};

export const useViewData = ({ option }: Props) => {
	const { viewData } = Converter.useViewDataConverter({ option });

	return {
		viewData,
	};
};
